module.exports = __webpack_public_path__ + "static/img/logo_first.40069ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_first.png
// module id = hQDS
// module chunks = 1